export function initPostcodeQuoteForm(): void {
  const postcodeQuoteForms = document.querySelectorAll<HTMLElement>('[data-component="postcode-quote-form"]');

  postcodeQuoteForms.forEach(form => {
    const input = form.querySelector<HTMLInputElement>('[data-component="postcode-quote-form-input"]');
    const cta = form.querySelector<HTMLAnchorElement>('[data-component="postcode-quote-form-cta"]');

    function updateCtaHref() {
      const postcode = input.value.trim();
      const baseUrl = cta.dataset.baseUrl || '#';

      if (postcode === '') {
        cta.href = baseUrl;
        return;
      }

      const encodedPostcode = encodeURIComponent(postcode);
      cta.href = `${baseUrl}?postcode=${encodedPostcode}`;
    }

    if (input && cta) {
      input.addEventListener('input', updateCtaHref);
      cta.addEventListener('click', updateCtaHref);
    }
  });
}

function getQueryVariable(variable: string): string | null {
  const query = globalThis.location.search.substring(1);
  const vars = query.split('&');

  for (const varPair of vars) {
    const pair = varPair.split('=');

    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }
}

export function updateFreshworksPostcodeInput(): void {
  const postcode = getQueryVariable('postcode');
  if (!postcode) return;

  const updatePostcodeField = () => {
    const fmFormElement = document.getElementsByName(
      'contact[custom_field][cf_waste_collection_postcode]'
    )[0] as HTMLInputElement;

    if (fmFormElement) {
      fmFormElement.value = postcode;
      return true;
    }
    return false;
  };

  if (updatePostcodeField()) return;

  const observer = new MutationObserver(() => {
    if (updatePostcodeField()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  setTimeout(() => observer.disconnect(), 10000);

  // Expose callback for Freshworks if it uses hooks
  (globalThis as any).FreshworksWebFormCallback = {
    afterInstall: updatePostcodeField,
  };
}

// Auto-initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPostcodeQuoteForm);
  document.addEventListener('DOMContentLoaded', updateFreshworksPostcodeInput);
} else {
  initPostcodeQuoteForm();
  updateFreshworksPostcodeInput();
}
